import CommonPasswordChange from '../../../common/pages/secure/PasswordChange'

class PasswordChange extends CommonPasswordChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
}

export default PasswordChange



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/PasswordChange.js